<template>
  <div>
    <div>
      <!-- Header -->
      <div class="">
        <div class="has-background-white has-shadow pa-md mb-lg">
          <div class="columns is-vcentered">
            <div class="column is-narrow">
              <a href="#" @click.prevent="toggleProject(baseProject.id)"><b-icon :icon="isExpanded ? 'menu-down' : 'menu-right'"></b-icon></a>
            </div>
            <div class="column">
              <div>
                <p class="has-text-weight-bold"><a href="#" @click.prevent="toggleProject(baseProject.id)">{{ baseProject.name }}</a></p>
                <p class="is-size-8 has-text-grey-light">
                  <StatusPresenter :project="baseProject" /> &bull;
                  {{ $dates(baseProject.start_date).format('MMM D, YYYY') }} - {{ $dates(baseProject.end_date).format('MMM D, YYYY') }}
                </p>
              </div>
            </div>
            <div class="column is-narrow">
              <a href="#" @click.prevent="navigateToProject(baseProject.id)"><b-icon icon="open-in-new" size="is-small"></b-icon></a>
            </div>
          </div>
        </div>
        <!-- Detail -->
        <div v-if="isExpanded" class="py-sm pl-xxl mb-md">
          <div  v-if="report">
            <!-- Project Totals -->
            <div class="mb-md">
              <div class="columns is-multiline">
                <div class="column is-half is-one-quarter-widescreen">
                  <div class="has-background-white">
                    <AllocationSummary :project="project" />
                  </div>
                </div>
                <div class="column is-half is-one-quarter-widescreen">
                  <div class="has-background-white">
                    <UtilizationSummary :project="project" />
                  </div>
                </div>
                <div class="column is-half is-one-quarter-widescreen">
                  <div class="has-background-white">
                    <BillingSummary :project="project" />
                  </div>
                </div>
                <div class="column is-half is-one-quarter-widescreen">
                  <div class="has-background-white">
                    <ExpenseSummary :project="project" />
                  </div>
                </div>
              </div>
            </div>
            <!-- Project Monthly -->
            <div class="has-background-white has-shadow pa-md mb-lg">
              <ProjectPeriods :billingPeriods="billingPeriods" :report="report" />
            </div>
            <!-- Project Weekly -->
            <div class="has-background-white has-shadow pa-md mb-lg">
              <ProjectWeeks :project="project" :focusBillingPeriod="focusBillingPeriod"  />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AllocationSummary from '../../../Projects/components/Lines/AllocationSummary'
import BillingSummary from '../../../Projects/components/Lines/BillingSummary'
import ExpenseSummary from '../../../Projects/components/Lines/ExpenseSummary'
import UtilizationSummary from '../../../Projects/components/Lines/UtilizationSummary'
import StatusPresenter from '@/components/Models/Project/Presenters/Status'
import ProjectPeriods from './ProjectPeriods'
import ProjectWeeks from './ProjectWeeks'

export default {
  components: {
    AllocationSummary,
    BillingSummary,
    ExpenseSummary,
    UtilizationSummary,
    StatusPresenter,
    ProjectPeriods,
    ProjectWeeks
  },
  computed: {
    ...mapGetters(['api', 'context']),
    loading () {
      return (this.loadingProject || this.loadingReport)
    }
  },
  data () {
    return {
      isExpanded: false,
      loadingProject: false,
      loadingReport: false,
      project: null,
      report: null
    }
  },
  methods: {
    navigateToProject (id) {
      const route = this.$router.resolve({ name: 'network.project.approve', params: { code: this.context.code, id: id } })
      window.open(route.href, '_blank')
    },
    toggleProject (id) {
      this.isExpanded = !this.isExpanded
      if (this.isExpanded) {
        this.loadProject(id)
      }
    },
    loadProject (id) {
      this.loadingProject = true
      this.loadingReport = true
      const projectEndpoint = this.api.route + '/projects/' + id
      this.$http.get(projectEndpoint).then(response => {
        this.project = response.data
        this.loadingProject = false
        const reportEndpoint = this.api.route + '/admin/reports/project-period'
        const query = {
          params: {
            project_id: id,
            start_billing_period_id: 1043,
            end_billing_period_id: 1054
          }
        }
        this.$http.get(reportEndpoint, query).then(response => {
          this.report = response.data
          this.loadingReport = false
        })
      })
    }
  },
  props: {
    billingPeriods: {
      type: Array,
      required: true
    },
    baseProject: {
      type: Object,
      required: true
    },
    focusBillingPeriod: {
      type: Object,
      required: true
    }
  }
}
</script>
